<template>
  <div class="d-flex flex-column min-vh-100" style="background-color: var(--bg-background); min-height: 100vh;">
    <main-header v-if="$store.state.user != null"/>
    <main id="app" class="flex-fill" role="main">
      <router-view/>
    </main>
    <footer class="text-muted text-center mb-2" style="color: var(--text-muted);">
      <b-container>
        <p>© 2024 Fix Audit. Все права защищены</p>
      </b-container>
    </footer>
  </div>
</template>

<script>
import MainHeader from './common/MainHeader';
export default {
  name: 'App',
  components: {
    MainHeader
  },
  mounted () {
    // DESIGN-2: Initialize theme — dark by default
    const savedTheme = localStorage.getItem('fix-audit-theme') || 'dark'
    document.documentElement.setAttribute('data-theme', savedTheme)
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--text-foreground);
  background-color: var(--bg-background);
}

/* Smooth theme transitions */
body {
  background-color: var(--bg-background);
  color: var(--text-foreground);
  transition: background-color 0.2s ease, color 0.2s ease;
}
</style>